// extracted by mini-css-extract-plugin
export default {"root":"Main_root__rH6iu","logos":"Main_logos__GIuR-","icon":"Main_icon__Zbw7n"};